import { Component, Input } from '@angular/core';
import { Movie, SquarePromo } from '../../services/Page/page.service';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { SearchService } from '../../services/Search/search.service';

@Component({
    selector: 'app-square-card',
    imports: [
        CommonModule,
        RouterModule
    ],
    templateUrl: './square-card.component.html',
    styleUrl: './square-card.component.scss'
})
export class SquarerCardComponent {
    @Input('promo') promo: SquarePromo | undefined
    @Input('isGenre') isGenre: boolean = false

    constructor(
        public searchService:SearchService,
        private router: Router
    ) {
        
    }

    onClick() {
        if(this.isGenre) {
            if(this.promo?.search) {
                this.searchService.searchByGenre(this.promo?.search, true)
            }
        }
        else {

            if(this.promo && this.promo?.search != '') {
                this.searchService.searchText = this.promo?.search;
                this.searchService.forceSearch$.next(this.promo?.search)
                this.router.navigate(['/search']);
            }
        }
    }
}
